import { React, useState, useEffect, useMemo } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import '../style/Home.css';
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { IoMdClose } from 'react-icons/io';
import { FaCheck } from 'react-icons/fa6';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';
import SocialIconModal from './SocialIconModal';
import { useStatsigClient } from '@statsig/react-bindings';

const Home = ({ setActive, locationUpdateCount }) => {
  const [OptionInd, setOptionInd] = useState(1);
  const [allList, setAllList] = useState([]);
  const [venueList, setVenueList] = useState([]);
  const navigate = useNavigate();
  const [profile, setprofile] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [venueLocation, setVenueLocation] = useState('');
  const [showMapModal, setShowMapModal] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [currentVenueForRating, setCurrentVenueForRating] = useState(null);
  const [currentVenueForModal, setCurrentVenueForModal] = useState(null);
  const [pills, setPills] = useState([]);
  const { client } = useStatsigClient();

  // console.log(OptionInd);
  const handleOption = (data, index) => {
    setOptionInd(index);
    let Venues = [];
    if (index === 1) {
      Venues = data;
    } else if (index === 2) {
      Venues = data.filter(venue => venue?.status !== 'active');
    } else if (index === 3) {
      Venues = data.filter(venue => venue?.status === 'active');
    } else if (index === 4) {
      Venues = data.filter(venue => venue?.distance <= 5000);
    } else if (index === 5) {
      Venues = data.filter(venue => venue?.distance <= 10000);
    } else if (index === 6) {
      Venues = data.filter(venue => venue?.distance <= 20000);
    } else if (index === 7) {
      Venues = data.filter(venue => venue?.distance <= 50000);
    } else if (index === 8) {
      Venues = data.filter(venue => venue?.distance <= 100000);
    } else if (index === 9) {
      Venues = data.filter(venue => venue?.isKJVenue);
    }

    return Venues;
  };

  const clickOnVenue = (
    vId,
    cost,
    buisnessvenue,
    vname,
    shoutoutcost,
    eventId,
    performer,
    status,
    excludedLabels
  ) => {
    localStorage.setItem('songCost', cost);
    localStorage.setItem('shoutOutCost', shoutoutcost);
    localStorage.setItem('isWebClicked', true);
    localStorage.setItem('isBussinessVenue', buisnessvenue);
    localStorage.setItem('EventId', eventId);
    localStorage.setItem('venueName', vname);
    localStorage.setItem('excludedLabels', excludedLabels);
    if (client) {
      client.logEvent('vCardClick', 'clicked', {
        source: localStorage.getItem('isQrEntry') == 'true' ? 'qrScan' : 'null',
        vName: vname,
        vID: vId,
        performer: performer,
        vtype: buisnessvenue ? 'Business' : 'Individual',
        status: status,
      });
    }
    navigate(`/venues/${vId}`);
  };

  const cancelMsg = () => {
    setIsError(false);
  };
  useEffect(() => {
    if (isError) {
      const timeout = setTimeout(() => {
        cancelMsg(); // Set isError to false
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [isError]);

  useEffect(() => {
    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      navigate('/');
      return;
    }
  }, [navigate]);

  useEffect(() => {
    const fetchvenues = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      let lat = localStorage.getItem('latitude');
      let lon = localStorage.getItem('longitude');

      let url = API_ENDPOINTS.VENUES;
      url += '?limit=1000';

      if (lat && lon) {
        lat = parseFloat(lat);
        lon = parseFloat(lon);
        url += `&lat=${lat}&lon=${lon}`;
      }

      // Add userId from profile if available
      if (profile && profile.id) {
        url += `&userId=${profile.id}`;
      }

      try {
        const venues = await fetchWithAuth(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!venues.ok) throw new Error('Failed to fetch data');

        const data = await venues.json();
        setAllList(data);
      } catch (error) {
        console.error('Error fetching songs:', error);
      }
    };

    fetchvenues();
    const interval = setInterval(fetchvenues, 4000);
    return () => clearInterval(interval);
  }, [profile, locationUpdateCount]); // Add profile as dependency so it refetches when profile changes

  const filteredVenues = useMemo(() => {
    const optionFiltered = handleOption(allList, OptionInd);
    if (!searchQuery) return optionFiltered;

    const lowerSearch = searchQuery.toLowerCase();

    return optionFiltered.filter(
      venue =>
        venue?.name.toLowerCase().includes(lowerSearch) ||
        (venue?.owner?.display_name &&
          venue?.owner?.display_name.toLowerCase().includes(lowerSearch)) ||
        (venue?.address?.city &&
          venue?.address?.city.toLowerCase().includes(lowerSearch))
    );
  }, [allList, OptionInd, searchQuery]);
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      //   console.log(token);

      try {
        const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        // console.log(data);
        setprofile(data);
      } catch (error) {
        console.error('Error fetching songs:', error);
      }
    };

    fetchProfile();
  }, []);
  useEffect(() => {
    const fetchPills = async () => {
      try {
        const response = await fetchWithAuth(API_ENDPOINTS.HOME_PILLS, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch pills');

        const data = await response.json();
        setPills(data.pills); // assuming you have a setPills state function
      } catch (error) {
        console.error('Error fetching pills:', error);
      }
    };
    fetchPills();
  }, []);
  function getVenueStatusBg(venue) {
    if (
      venue?.isBussinessVenue &&
      (venue?.status === undefined ||
        venue?.status === null ||
        venue?.status === 'approved')
    ) {
      return '#fff';
    }
    if (venue?.status === 'active') return '#0F6D01';
    if (venue?.status === 'paused') return '#FFA500';
    if (venue?.status === 'approved') return '#D0151C';
    return '#D0151C';
  }

  function formatDate(dateString, withTime = false) {
    if (!dateString) return '--';
    const date = new Date(dateString);
    if (isNaN(date)) return '--';

    const datePart = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });

    if (withTime) {
      const timePart = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      });
      return `${datePart}, ${timePart}`;
    }

    return datePart;
  }

  const handleRatingClick = (venue, e) => {
    e.stopPropagation();
    setCurrentVenueForRating(venue);
    setShowRatingModal(true);
  };
  const handleMapClick = (venue, e) => {
    e.stopPropagation();
    setCurrentVenueForModal(venue);
    setShowMapModal(true);
  };

  function getVenueStatusLabel(venue) {
    // Show ratings for business venues if status is null/undefined or "approved"
    if (
      venue?.isBussinessVenue &&
      (venue?.status === undefined ||
        venue?.status === null ||
        venue?.status === 'approved')
    ) {
      return (
        <div
          style={{ position: 'relative', display: 'inline-block' }}
          onClick={e => handleRatingClick(venue, e)}
        >
          {/* Green Rating Box */}
          <div
            style={{
              border: '1px solid #000',
              borderRadius: '6px',
              background: 'green',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              minWidth: '70px',
              marginBottom: '2px',
              padding: '1.5px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span style={{ color: '#FFD700', fontSize: '12px' }}>★</span>
              <span
                style={{ fontWeight: 600, fontSize: '12px', color: 'white' }}
              >
                {venue?.rating ? venue.rating.toFixed(1) : '0.0'}
              </span>
            </div>
          </div>
          {/* Google Capsule Image */}
          <img
            src="/images/google.png"
            alt="Google"
            style={{
              position: 'absolute',
              top: '18.3px',
              left: '52%',
              transform: 'translateX(-50%)',
              height: '11px',
              width: '41px',
              borderRadius: '20px',
              backgroundColor: 'white',
              padding: '0.4px 2px',
            }}
          />

          {/* Reviews */}
          <span
            style={{
              fontSize: '9px',
              color: '#666',
              marginTop: '7px',
              width: '80px',
              display: 'block',
              textAlign: 'center',
            }}
          >
            (
            {venue?.user_ratings_total > 100
              ? (venue.user_ratings_total / 1000).toFixed(1) + 'k'
              : venue?.user_ratings_total || 0}{' '}
            reviews)
          </span>
        </div>
      );
    }
    if (venue?.status === 'active')
      return (
        <>
          Live
          {venue?.date && (
            <span style={{ marginLeft: 6, fontSize: 10, color: '#eee' }}>
              {formatDate(venue.date, true)}
            </span>
          )}
        </>
      );
    if (venue?.status === 'paused') return 'Paused';
    if (venue?.status === 'approved' || venue?.status === 'upcoming') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <span>Upcoming</span>
        </div>
      );
    }
    return 'Upcoming';
  }

  return (
    <div className="home-container">
      {isError && (
        <div
          style={{
            position: 'fixed',
            bottom: '80px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            color: 'white',
            background: 'rgba(236, 236, 236, 1)',
            borderRadius: '20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.32)',
            padding: '16px 24px',
            minWidth: '300px',
            maxWidth: '90vw',
            animation: 'slideDown 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <img
            src="/images/logo.svg"
            style={{
              width: '18px',
              height: '18px',
              flexShrink: 0,
            }}
          />
          <div
            style={{
              color: 'black',
              fontSize: '13px',
              lineHeight: '1.4',
            }}
          >
            {typeof errorMsg === 'string'
              ? errorMsg
              : errorMsg?.message || 'Something went wrong'}
          </div>
        </div>
      )}

      <div
        className="d-flex flex-column align-items-center overflow-scroll position-relative"
        style={{ scrollBehavior: 'smooth', height: '92dvh' }}
      >
        <div
          className="w-100 d-flex flex-column align-items-center pt-2"
          style={{ top: 0, background: 'white', zIndex: 900 }}
        >
          <div
            className="d-flex flex-row justify-content-between align-items-center mt-1 mb-2"
            style={{ width: '95%' }}
          >
            <div className="d-flex flex-row align-items-center">
              <img
                src="/images/logo.svg"
                className=""
                style={{ marginRight: '10px', height: '32px' }}
                onClick={() => setActive(5)}
              />
              <button
                className="location-btn py-1 px-2"
                onClick={() => navigate('/location')}
              >
                <span style={{ fontSize: '14px' }}>
                  {localStorage.getItem('selectedCity')
                    ? localStorage.getItem('selectedCity')
                    : 'All Cities'}{' '}
                  <IoIosArrowDown />
                </span>
              </button>
            </div>
            <button
              onClick={() => navigate('/buy')}
              className="text-end py-0"
              style={{
                position: 'relative',
                border: '1.321px solid #FED111',
                borderRadius: '20px ',
                color: 'black',
                textDecoration: 'none',
                outline: 'none',
                background: 'transparent',
                padding: 0,
              }}
            >
              <span
                className="text-end d-flex flex-row align-items-center"
                style={{
                  color: 'black',
                  borderColor: 'white',
                  gap: '5px',
                  paddingRight: '10px',
                  paddingLeft: '0px',
                }}
              >
                <img
                  src="/images/coin.svg"
                  className=""
                  style={{
                    height: '30px',
                  }}
                />
                {profile.coins || 0}
              </span>
            </button>
          </div>

          <div className="home-search-container mb-2" style={{ width: '95%' }}>
            <input
              placeholder="Search Venues"
              type="text"
              className="home-search-input px-2 py-2 w-100"
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>

          <div
            className="home-options d-flex flex-row justify-content-start py-1 mt-1 mb-1"
            style={{
              gap: '10px',
              width: '95%',
              overflow: 'scroll',
              scrollBehavior: 'smooth',
            }}
          >
            {/* Render All, Active, Upcoming in order */}
            {['All', 'Active', 'Upcoming'].map(
              (pill, idx) =>
                pills.includes(pill) && (
                  <button
                    key={pill}
                    className="home-option py-1 px-3 d-flex align-items-center justify-content-center"
                    style={{
                      border: 'none',
                      background:
                        OptionInd ===
                        (pill === 'All' ? 1 : pill === 'Active' ? 3 : 2)
                          ? 'linear-gradient(90deg, #DB0F11 0%, #863663 100%)'
                          : 'white',
                      color:
                        OptionInd ===
                        (pill === 'All' ? 1 : pill === 'Active' ? 3 : 2)
                          ? 'white'
                          : '#d7080c',
                      fontSize: 'clamp(0px,4vw,20px)',
                      flexGrow: 1,
                      gap: '6px',
                    }}
                    onClick={() =>
                      handleOption(
                        allList,
                        pill === 'All' ? 1 : pill === 'Active' ? 3 : 2
                      )
                    }
                  >
                    {pill === 'Active' ? (
                      <>
                        Live Now
                        <span
                          style={{
                            display: 'inline-block',
                            width: '8px',
                            height: '8px',
                            backgroundColor: 'limegreen',
                            borderRadius: '50%',
                            marginLeft: '3px',
                          }}
                        />
                      </>
                    ) : (
                      pill
                    )}
                  </button>
                )
            )}

            {/* Render the rest of the pills */}
            {pills
              .filter(pill => !['All', 'Active', 'Upcoming'].includes(pill))
              .map((pill, idx) => (
                <button
                  key={pill}
                  className="home-option py-1 px-3"
                  style={{
                    border: 'none',
                    background:
                      OptionInd ===
                      (pill === 'Karaoke'
                        ? 9
                        : pill === 'Under 5 km'
                          ? 4
                          : pill === 'Under 10 km'
                            ? 5
                            : pill === 'Under 20 km'
                              ? 6
                              : pill === 'Under 50 km'
                                ? 7
                                : pill === 'Under 100 km'
                                  ? 8
                                  : 0)
                        ? 'linear-gradient(90deg, #DB0F11 0%, #863663 100%)'
                        : 'white',
                    color:
                      OptionInd ===
                      (pill === 'Karaoke'
                        ? 9
                        : pill === 'Under 5 km'
                          ? 4
                          : pill === 'Under 10 km'
                            ? 5
                            : pill === 'Under 20 km'
                              ? 6
                              : pill === 'Under 50 km'
                                ? 7
                                : pill === 'Under 100 km'
                                  ? 8
                                  : 0)
                        ? 'white'
                        : '#d7080c',
                    fontSize: 'clamp(0px,4vw,20px)',
                    flexGrow: 1,
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() =>
                    handleOption(
                      allList,
                      pill === 'Karaoke'
                        ? 9
                        : pill === 'Under 5 km'
                          ? 4
                          : pill === 'Under 10 km'
                            ? 5
                            : pill === 'Under 20 km'
                              ? 6
                              : pill === 'Under 50 km'
                                ? 7
                                : pill === 'Under 100 km'
                                  ? 8
                                  : 0
                    )
                  }
                >
                  {pill}
                </button>
              ))}
          </div>
        </div>

        {filteredVenues?.length > 0 ? (
          <div className="" style={{ width: '95%', marginBottom: '100px' }}>
            {filteredVenues.map((venue, index) => (
              <button
                key={index}
                className="mt-2 p-0 w-100 position-relative"
                style={{ border: 'none', background: 'transparent' }}
                onClick={e => {
                  e.stopPropagation();
                  const dateObj = new Date(venue?.startAt);

                  // Format: "15 April" and "6:30 PM"
                  const dateString = dateObj.toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'long',
                  });

                  const timeString = dateObj.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true,
                  });

                  clickOnVenue(
                    venue?.id,
                    venue?.songRequestCoins,
                    venue?.isBussinessVenue,
                    venue?.name,
                    venue?.shoutOutRequestCoins,
                    venue?.eventId,
                    venue?.display_name,
                    venue?.status,
                    venue?.excludeLabels
                  );
                }}
              >
                {/* {console.log(venue)} */}
                <div
                  style={{
                    backgroundImage: `url(${venue?.photoUrl})`,
                    height: '18dvh',
                    borderRadius: '10px 10px 25px 25px',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'none',
                    backgroundSize: '100% 100%',
                    marginBottom: '-17px',
                  }}
                  className="w-100 position-relative"
                >
                  <img
                    src="/images/arch-divider.png"
                    alt=""
                    style={{
                      position: 'absolute',
                      top: -2,
                      width: '100%',
                      left: 0,
                      height: '14px',
                    }}
                  />
                  {/* <img
                    src={venue?.owner?.avatar}
                    style={{
                      background: "black",
                      borderRadius: "50%",
                      height: "60px",
                      aspectRatio: "1/1",
                      position: "absolute",
                      bottom: "-3px",
                      left: "-0px",
                      border: "solid 1px white",
                      display:venue?.category === "device"?"none":"block"
                    }}
                  /> */}

                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      position: 'absolute',
                      top: '18px',
                      right: '10px',
                      borderRadius: '10px',
                      background: 'url(/images/figmacurve.svg)',
                      backgroundRepeat: 'none',
                      backgroundPosition: 'center',
                      backgroundSize: '100% 100%',
                    }}
                    onClick={e => handleMapClick(venue, e)}
                  >
                    <span
                      style={{
                        color: '#D0151C',
                        fontSize: 'clamp(0px,2.5vw,16px)',
                        position: 'relative',
                      }}
                      className="p-2"
                    >
                      {/* <img src="/images/figmacurve.svg"/> */}
                      <b className="m-0 p-0">
                        {venue?.distance
                          ? (venue.distance / 1000).toFixed(1)
                          : ''}{' '}
                        KM
                      </b>
                    </span>
                  </div>
                </div>
                <div
                  className="w-100 px-3 pt-3 pb-2"
                  style={{
                    border: 'solid 1px #CA1722',
                    borderRadius: '0px 0px 10px 10px',
                    borderTop: 'none',
                  }}
                >
                  <div className="d-flex flex-row justify-content-between text-start pt-2 mb-1">
                    <div className="col-9 overflow-hidden d-flex flex-column justify-content-between py-1">
                      <h6
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          margin: '0px',
                          color: '#4C4C4C',
                          fontSize: '17px',
                          fontWeight: '700',
                        }}
                      >
                        {venue.name}
                      </h6>
                      {venue.owner ? (
                        <span
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            fontSize: '14px',
                            color: '#9C9C9C',
                          }}
                        >
                          {venue.owner.display_name}, {venue?.address?.city}
                        </span>
                      ) : (
                        <span></span>
                      )}
                    </div>
                    <div
                      style={{
                        borderRadius: '5px',
                        background: '#fff',
                        overflow: 'hidden',
                      }}
                      className="d-flex flex-column align-items-center col-3 text-center"
                    >
                      <span
                        className="px-2 py-1 w-100"
                        style={{
                          background: getVenueStatusBg(venue),
                          color:
                            venue?.status === undefined ||
                            venue?.status === null
                              ? '#000'
                              : 'white',
                          fontSize: 'clamp(0px,2.8vw,10px)',
                          borderRadius: '5px 5px 0 0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '4px',
                          maxWidth: '70px',
                          marginTop: '2px',
                        }}
                      >
                        {getVenueStatusLabel(venue)}
                      </span>

                      {/* Bottom label */}
                      {/* Bottom label */}
                      {
                        // Only show date if NOT a business venue with status approved/null/undefined
                        !(
                          venue?.isBussinessVenue &&
                          (venue?.status === undefined ||
                            venue?.status === null ||
                            venue?.status === 'approved')
                        ) &&
                          (() => {
                            const endDate = new Date(venue?.endAt);
                            const startDate = new Date(venue?.startAt);
                            if (venue?.endAt && !isNaN(endDate)) {
                              return (
                                <span
                                  className=" py-0.5 w-100"
                                  style={{
                                    padding: '2px 4px',
                                    border: 'solid .5px #6D6D6D',
                                    color: '#6D6D6D',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    fontSize: 'clamp(0px,2.4vw,10px)',
                                    borderRadius: '0 0 5px 5px',
                                    maxWidth: '70px',
                                  }}
                                >
                                  {venue?.status === 'active'
                                    ? `Till ${endDate.toLocaleTimeString(
                                        'en-US',
                                        {
                                          hour: 'numeric',
                                          minute: '2-digit',
                                          hour12: true,
                                        }
                                      )}`
                                    : `${startDate.toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                      })}, ${startDate.toLocaleTimeString(
                                        'en-US',
                                        {
                                          hour: 'numeric',
                                          minute: '2-digit',
                                          hour12: false,
                                        }
                                      )}`}
                                </span>
                              );
                            }
                            return null;
                          })()
                      }
                    </div>
                  </div>
                  <div
                    className="d-flex flex-row align-items-center w-100 mt-2 mb-1"
                    style={{
                      whiteSpace: 'nowrap',
                      gap: '8px',
                      overflow: 'hidden',
                    }}
                  >
                    {/* THEME TAGS: HORIZONTALLY SCROLLABLE, NEVER WRAP */}
                    {venue?.themes?.length > 0 && (
                      <div
                        className="d-flex flex-row align-items-center"
                        style={{
                          gap: '3px',
                          overflowX: 'auto',
                          overflowY: 'hidden',
                          whiteSpace: 'nowrap',
                          flexShrink: 0,
                          maxWidth: '75%', // Adjust as needed for your card layout
                        }}
                      >
                        {venue?.themes?.map((theme, index) => (
                          <div
                            key={index}
                            className="py-0 px-1"
                            style={{
                              fontSize: '10px',
                              background: 'rgba(255,255,255,0.8)',
                              border: '1px solid #CECECE',
                              borderRadius: '4px',
                              display: 'inline-block',
                              whiteSpace: 'nowrap',
                              padding: '1px 4px',
                              margin: 0,
                              lineHeight: 1.2,
                            }}
                          >
                            <span style={{ color: 'rgba(250, 92, 67, 0.8)' }}>
                              {theme}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* ADDRESS: TAKES REMAINING SPACE, TRUNCATES IF NEEDED */}
                    <span
                      className="common-txt text-start"
                      style={{
                        fontSize: 'clamp(0px,2.8vw,10px)',
                        color: '#9A9A9A',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        flex: 1,
                        minWidth: 0,
                      }}
                      title={`${venue?.address?.line1}${
                        venue?.address?.line2
                          ? `, ${venue?.address?.line2}`
                          : ''
                      }`}
                    >
                      {`${venue?.address?.line1}${
                        venue?.address?.line2
                          ? `, ${venue?.address?.line2}`
                          : ''
                      }`}
                    </span>
                  </div>
                </div>
              </button>
            ))}
            <SocialIconModal
              isOpen={showRatingModal}
              onClose={() => {
                setShowRatingModal(false);
                setCurrentVenueForRating(null);
              }}
              socialName={'Google Ratings'}
              href={currentVenueForRating?.google_review_url || ''}
              message="See Google ratings and reviews for this event."
            />
            <SocialIconModal
              isOpen={showMapModal}
              onClose={() => {
                setShowMapModal(false);
                setCurrentVenueForModal(null);
              }}
              socialName={'Maps'}
              href={
                currentVenueForModal?.geometry?.coordinates
                  ? `https://www.google.com/maps/dir/?api=1&destination=${currentVenueForModal.geometry.coordinates[1]},${currentVenueForModal.geometry.coordinates[0]}`
                  : 'https://www.google.com/maps'
              }
              message="Want to see the directions for the event?"
            />
          </div>
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ flexGrow: 1, width: '100%' }}
          >
            {OptionInd === 1 ? (
              <Spinner
                animation="border"
                role="status"
                style={{
                  color: 'red',
                  height: '10dvh',
                  aspectRatio: '1/1',
                  width: '10dvh',
                }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <div></div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
